import {z} from '@hono/zod-openapi';

export const priceReportObjectionSchema = z
  .object({
    objection: z.string(),
    response: z.string(),
    factIds: z.array(z.string()),
  })
  .openapi('PriceReportObjection');

export type PriceReportObjection = z.infer<typeof priceReportObjectionSchema>;
